import { Avatar } from 'primereact/avatar'
import { Menu } from 'primereact/menu'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { signOutFromFirebase } from '../../firebase/firebaseSetup'
import { SalutationCt, UserAccountType } from '../../model/enums/enums'
import { MokaiUser } from '../../model/mokaiUser'
import { Apprentice, Person } from '../../model/person.model'
import { removedUser } from '../../redux/basic/user/userSlice'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { AppHeaderRoutes_Authorized, MokaiRoute } from '../../router/routes'
import { getUserAvatar, getUserAvatarSrc } from '../../util/getAvatar'
import { hasClaim } from '../../util/validation/hasClaim'

export const UserAvatar = () => {
  const [navItems, setNavItems] = useState<any[]>([])

  const user = useAppSelector((state) => state.user)
  const claims = useAppSelector((state) => state.claims)

  const person = useAppSelector((state) =>
    [...state.apprentices, ...state.employees].find(
      (pers: Apprentice | Person) => pers.person_id === user?.personId
    )
  )

  const [userAvatar, setUserAvatar] = useState<string>(
    getUserAvatar(SalutationCt.NoSpecification, UserAccountType.NoAccount)
  )

  const menu = useRef<Menu>(null)

  const setItems = (mokaiUser: MokaiUser) => {
    const authItem = []
    //  todo verify
    // eslint-disable-next-line array-callback-return
    AppHeaderRoutes_Authorized.map((route: MokaiRoute) => {
      if (hasClaim(claims, route.mainModule)) {
        authItem.push({
          label: t('navigation.' + route.name),
          icon: route.icon,
          command: () => navigate(route.path),
        })
      }
    })
    if (mokaiUser?.firebaseUser) {
      if (authItem.length > 0) {
        authItem.push({ separator: true })
      }
      authItem.push({
        label: t<string>('core.sign_out'),
        icon: 'fas fa-sign-out-alt',
        command: () => signOut(),
      })
    }
    setNavItems(authItem)
  }

  useEffect(() => {
    if (!claims || claims.length === 0) {
      return
    }
    setItems(user)
  }, [claims.length])

  useEffect(() => {
    setUserAvatar(getUserAvatarSrc(person))
  }, [person?.profile_image_thumbnail_ref])

  const dispatcher = useAppDispatch()

  // t needs to be kept for correct translation in route
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [t, i18n] = useTranslation()

  const navigate = useNavigate()

  const signOut = async () => {
    localStorage.removeItem('mokai-user')
    dispatcher(removedUser())
    await signOutFromFirebase()
    console.log('Successfully signed out. Redirecting to login.')
    window.location.reload()
  }

  return (
    <div className={'mr-0 pr-0'}>
      <Menu
        model={navItems}
        popup={true}
        ref={menu}
        className="header-popup-menu"
      />
      <Avatar
        image={userAvatar}
        shape={'circle'}
        size={'xlarge'}
        onClick={(event) => menu.current?.toggle(event)}
        aria-controls="header_popup_menu"
        aria-haspopup
      />
    </div>
  )
}